import shoesReflection from '../../../../assets/svgs/actors/bennettReflection/shoesReflection'

import { SHOES_REFLECTION } from '../../../../constants/scene/actors/bennett'

export default {
    [SHOES_REFLECTION]: shoesReflection,
}
